import { Axios } from "../../service/serviceBasic";
import { AxiosCadastro } from "../../service/serviceBasic";

import {
  SET_NAVEGATION_STEPS,
  LOADING_NAVEGATION_STEPS,
  SET_ERROR_NAVEGATION_STEPS,
  SET_CURRENT_NAVEGATION_STEPS,
  SET_CURRENT_STEP,
  SET_VALIDATE_FIELDS,
  SET_IS_VALID_FIELDS,
} from "./types";

export const setNavegationStepsAction = (steps) => ({
  type: SET_NAVEGATION_STEPS,
  payload: steps,
});

const loadingNavegationStepsAction = (flag) => ({
  type: LOADING_NAVEGATION_STEPS,
  payload: flag,
});

const setErrorNavegationStepsAction = (message) => ({
  type: SET_ERROR_NAVEGATION_STEPS,
  payload: message,
});

export const setCurrentNavegationStepsAction = (steps) => ({
  type: SET_CURRENT_NAVEGATION_STEPS,
  payload: steps,
});

export const setCurrentStepAction = (step) => ({
  type: SET_CURRENT_STEP,
  payload: step,
});

export const getNavegationStepsAction = () => (dispatch) => {
  dispatch(loadingNavegationStepsAction(true));
  AxiosCadastro.get(
    "v1/Modelador/get",
    {},
    { headers: { "Cache-Control": "no-cache" } }
  )
    .then((response) => {
      dispatch(setNavegationStepsAction(response.data));
    })
    .catch((error) => {
      dispatch(setErrorNavegationStepsAction(error.message));
    })
    .finally(() => {
      dispatch(loadingNavegationStepsAction(false));
    });
};

export const setValidateFieldsAction = (flag) => ({
  type: SET_VALIDATE_FIELDS,
  payload: flag,
});

export const setIsValidFieldsAction = (flag) => ({
  type: SET_IS_VALID_FIELDS,
  payload: flag,
});
